import { Link } from "react-router-dom";

export default function QuoteCTA() {
  return (
    <section className="w-full px-6 md:px-12 lg:px-20 py-24 md:py-32 bg-primary-500">
      <div className="max-w-4xl mx-auto text-center">
        <div className="flex items-center justify-center gap-3 mb-6">
          <span className="w-8 h-px bg-background-50/50" />
          <span className="font-label text-[11px] tracking-[0.22em] uppercase text-background-50/80">
            Get Started
          </span>
          <span className="w-8 h-px bg-background-50/50" />
        </div>
        <h2 className="font-heading text-background-50 text-4xl md:text-5xl lg:text-6xl leading-[1.05] font-light">
          Ready to source
          <br />
          <span className="italic">Korean beauty products?</span>
        </h2>
        <p className="mt-6 max-w-2xl mx-auto text-background-50/85 text-base md:text-lg leading-relaxed font-light">
          Tell us what you need — brands, products, quantities and destination. Our export team will prepare a tailored wholesale quotation with availability, pricing, MOQ guidance and recommended shipping options.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact"
            className="whitespace-nowrap cursor-pointer group inline-flex items-center gap-4 pl-7 pr-3 py-3 rounded-full bg-background-50 text-foreground-950 hover:bg-accent-100 transition-colors"
          >
            <span className="font-label text-sm tracking-[0.16em] uppercase">
              Request a Wholesale Quote
            </span>
            <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 group-hover:bg-accent-500 transition-colors">
              <i className="ri-arrow-right-up-line text-base" />
            </span>
          </Link>
          <a
            href="mailto:kwonkhkorea@gmail.com"
            rel="nofollow"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-50/40 text-background-50 hover:bg-background-50/10 transition-colors font-label text-[13px] tracking-[0.12em] uppercase"
          >
            Email Directly
            <i className="ri-mail-line" />
          </a>
        </div>
        <p className="mt-8 text-background-50/60 text-[13px] font-light">
          We normally respond within one business day.
        </p>
      </div>
    </section>
  );
}